import { Component, Input } from '@angular/core';
import { AvatarSize } from '@interfaces/common.interface';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  localImage = '';
  @Input() size: AvatarSize = 'medium';
  @Input() set image(value: string | undefined) {
    if (value) {
      if (/https?:\/\//.test(value)) {
        this.localImage = value;
      } else {
        this.localImage = environment.imageBaseUrl + value;
      }
    } else {
      this.localImage = '';
    }
  }
  get image(): string | undefined {
    return this.localImage;
  }

  constructor() {}
}
